import * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
// TODO: this is just a placeholder for now
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'test',
      type: core.mosaic.Widget.Type.TreeEditor,
      content: {
        '{}': {
          nodes: {
            '@': 'outcomes',
          },
        },
      },
    },
  },
  subqueries: {
    outcomes: {
      selection: {
        '{}': {
          label: {
            '@.': '!name',
          },
          modelId: {
            '@_': 'id',
          },
          values: { '@.*': {} },
        },
      },
      target: 'dim::!outcomes',
    },
  },
}
